import { ReactSVG } from 'react-svg'
import { useContext } from 'react'
import { ConfigContext } from '../../context/ConfigContext'

type IconDefaultHiddenProps = {
  svgUrl?: string;
}

const IconDefaultHidden: React.FC<IconDefaultHiddenProps> = ({ svgUrl }) => {
  if (!svgUrl) return null
  return (
    <ReactSVG wrapper="span" src={svgUrl} />
  )
}

type IconWithFallbackProps = {
  svgUrl?: string;
  ariaLabel?: string;
  fallbackSvgUrl: string;
}

const IconWithFallback: React.FC<IconWithFallbackProps> = ({ svgUrl, fallbackSvgUrl, ariaLabel }) => (
  <ReactSVG role="img" aria-label={ariaLabel} wrapper="span" src={svgUrl ?? fallbackSvgUrl} />
)

export const ArrowLeft: React.FC = () => {
  const { configContext } = useContext(ConfigContext)
  return <IconDefaultHidden svgUrl={configContext?.leftArrowSvgUrl} />
}

export const ArrowDown: React.FC = () => {
  const { configContext } = useContext(ConfigContext)
  return (
    <IconWithFallback
      svgUrl={configContext?.downArrowSvgUrl}
      fallbackSvgUrl="/images/arrow_tall_down.svg"
    />
  )
}

export const AudioOff: React.FC = () => {
  const { configContext } = useContext(ConfigContext)
  return (
    <IconWithFallback
      svgUrl={configContext?.audioOffSvgUrl}
      fallbackSvgUrl="/images/audio_off.svg"
    />
  )
}

export const AudioOn: React.FC = () => {
  const { configContext } = useContext(ConfigContext)
  return (
    <IconWithFallback
      svgUrl={configContext?.audioOnSvgUrl}
      fallbackSvgUrl="/images/audio_on.svg"
    />
  )
}

export const AudioDescription: React.FC = () => {
  const { configContext } = useContext(ConfigContext)
  return (
    <IconWithFallback
      ariaLabel="The selected track is an Audio Description"
      svgUrl={configContext?.audioDescriptionSvgUrl}
      fallbackSvgUrl="/images/audio_description.svg"
    />
  )
}

export const Loader: React.FC = () => {
  const { configContext } = useContext(ConfigContext)
  return (
    <IconWithFallback
      svgUrl={configContext?.loaderSvgUrl}
      fallbackSvgUrl="/images/loader.svg"
    />
  )
}

export const ClosedCaptions: React.FC = () => {
  const { configContext } = useContext(ConfigContext)
  return (
    <IconWithFallback
      svgUrl={configContext?.closedCaptionsSvgUrl}
      fallbackSvgUrl="/images/closed_captions.svg"
    />
  )
}

// TODO: add settingsSvgUrl to the admin settings form
export const Settings: React.FC = () => (
  // const { configContext } = useContext(ConfigContext)
  <IconWithFallback
    ariaLabel="Settings Icon"
    // svgUrl={configContext?.settingsSvgUrl}
    fallbackSvgUrl="/images/settings.svg"
  />
)

// TODO: add closeSvgUrl to the admin settings form
export const CloseX: React.FC = () => (
  // const { configContext } = useContext(ConfigContext)
  <IconWithFallback
    ariaLabel="Close X Icon"
    // svgUrl={configContext?.settingsSvgUrl}
    fallbackSvgUrl="/images/close-x.svg"
  />
)

export const AllIconsPreloader: React.FC = () => (
  <div style={{ display: 'none' }}>
    <ArrowLeft />
    <ArrowDown />
    <AudioOff />
    <AudioOn />
    <ClosedCaptions />
    <AudioDescription />
    <Settings />
    <Loader />
  </div>
)
